module.exports = __webpack_public_path__ + "dist/assets/img/motionvideo.27305dff.svg";